module.exports = __webpack_public_path__ + "static/media/homepage_atf_4.c2f87531.png";